import { render, staticRenderFns } from "./GoalResultTable.vue?vue&type=template&id=5abc71f3&scoped=true"
import script from "./GoalResultTable.vue?vue&type=script&lang=js"
export * from "./GoalResultTable.vue?vue&type=script&lang=js"
import style0 from "./GoalResultTable.vue?vue&type=style&index=0&id=5abc71f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abc71f3",
  null
  
)

export default component.exports